import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

import {
  BulkDiscount,
  getHighestBulkDiscount,
  getSelectedBulkDiscount
} from '@/shared/utils/discounts';

import { useProductStore } from './product';

export const useProductQuantitiesStore = defineStore(
  'product-quantities',
  () => {
    const bulkDiscounts = ref<BulkDiscount[]>([]);
    const quantity = ref(1);
    const showQuantityModal = ref(false);

    const selectedBulkDiscount = (target: number = quantity.value) => {
      return getSelectedBulkDiscount(bulkDiscounts.value, target);
    };

    const highestDiscountItem = () => {
      return getHighestBulkDiscount(bulkDiscounts.value);
    };

    const setBulkDiscounts = (discounts: BulkDiscount[]) => {
      bulkDiscounts.value = discounts;
    };

    const bulkDiscountsAvailable = computed(() => bulkDiscounts.value.length);

    const updateQuantity = (payload: number) => {
      quantity.value = payload;

      const priceCouldChange = bulkDiscounts.value.length > 0;
      if (priceCouldChange) {
        const productStore = useProductStore();
        productStore.updatePriceByQuantity();
      }
    };

    return {
      bulkDiscounts,
      quantity,
      showQuantityModal,
      selectedBulkDiscount,
      highestDiscountItem,
      updateQuantity,
      setBulkDiscounts,
      bulkDiscountsAvailable
    };
  }
);
